// extracted by mini-css-extract-plugin
export default {"tableWrapper":"table_tableWrapper__vRmDN","table":"table_table__YhSKi","status":"table_status__rvGn3","active":"table_active__6pnTn","inactive":"table_inactive__FcrpC"};